import React from "react";
import {
    PAYMENT_REQUEST_HAWALA_GET_LIST_API,
    PAYMENT_REQUEST_MISC_GET_LIST_API
} from "const/apiMethods";
import { checkPermissionsFor } from "store/storeHelpers";
import { Spacer } from "components/base/Spacer";
import PageTabs from "components/PageTabs";

const menuItems = [
    { id: "payment-requests", eventKey: "payment-requests", title: "Payment requests" },
    { id: "payments", eventKey: "payments", title: "Payments" },
    { id: "invoices", eventKey: "invoices", title: "Invoices" },
    {
        id: "hawala-payment-request",
        eventKey: "hawala-payment-request",
        title: "Hawala payment request",
        checkMethods: [PAYMENT_REQUEST_HAWALA_GET_LIST_API]
    },
    {
        id: "misc-payment-request",
        eventKey: "misc-payment-request",
        title: "Misc payments",
        checkMethods: [PAYMENT_REQUEST_MISC_GET_LIST_API]
    },
];


export default ({
    activeTab,
    onSelect
}) => {
    const filteredMenuItems = menuItems.filter(item => {
        if (!item.checkMethods) return true;

        return item.checkMethods.every(method => checkPermissionsFor(method));
    });

    return (
        <>
            <PageTabs
                {...{ activeTab, onSelect, menuItems: filteredMenuItems }}
            />
            <Spacer size={30} />
        </>
    );
};